<div class="row">
  <div class="col-12">
    <h2
      aria-controls="section85">
      Tableau résumé du roulement selon l'article 85
    </h2>
    <table class="table table-light">
      <thead>
        <tr>
          <th rowspan="2" scope="col"></th>
          <th rowspan="2" scope="col">Juste valeur marchande des biens transférés</th>
          <th rowspan="2" scope="col">Coût indiqué</th>
          <th class="table-col-split" rowspan="2" scope="col">Somme convenue</th>
          <th class="table-col-split" colspan="2" scope="col">Contrepartie autre qu'en actions</th>
          <th colspan="4" scope="col">Actions</th>
        </tr>
        <tr>
          <th scope="col">Description</th>
          <th class="table-col-split" scope="col">JVM</th>
          <th scope="col">Description</th>
          <th scope="col">PBR</th>
          <th scope="col">CV</th>
          <th scope="col">JVM</th>
        </tr>
      </thead>
      @for (propertyTransferredResults of results.propertiesTransferred; track propertyTransferredResults; let i = $index) {
        <tbody>
          <tr>
            <th scope="row">{{ propertyTransferredResults.title }}</th>
            <td>{{ propertyTransferredResults.fairMarketValue | currencyCents | notAvailable }}</td>
            <td>{{ propertyTransferredResults.costAmount | currencyCents | notAvailable }}</td>
            <td class="table-col-split">{{ propertyTransferredResults.agreedAmount | currencyCents | notAvailable }}</td>
            <td>
              @for (nonShareConsideration of propertyTransferredResults.nonShareConsiderations; track nonShareConsideration; let i = $index) {
                <span>
                  @if (shouldShowNonShareConsideration(nonShareConsideration)) {
                    <div>
                      {{ getTitleForNonShareConsideration(nonShareConsideration) }}
                    </div>
                  }
                </span>
              }
            </td>
            <td class="table-col-split">
              @for (nonShareConsideration of propertyTransferredResults.nonShareConsiderations; track nonShareConsideration; let i = $index) {
                <span>
                  @if (shouldShowNonShareConsideration(nonShareConsideration)) {
                    <div>
                      {{ nonShareConsideration.amountOfNonShareConsideration | currencyCents | notAvailable }}
                    </div>
                  }
                </span>
              }
            </td>
            <td>
              @for (commonShareClass of propertyTransferredResults.commonSharesClasses; track commonShareClass; let i = $index) {
                <div>
                  {{ commonShareClass.numberOfShares }} {{ commonShareClass.title }}
                </div>
              }
              @for (preferredShareClass of propertyTransferredResults.preferredSharesClasses; track preferredShareClass; let i = $index) {
                <div>
                  {{ preferredShareClass.numberOfShares }} {{ preferredShareClass.title }}
                </div>
              }
            </td>
            <td>
              @for (commonShareClass of propertyTransferredResults.commonSharesClasses; track commonShareClass; let i = $index) {
                <div>
                  {{ commonShareClass.adjustedCostBase | currencyCents | notAvailable }}
                </div>
              }
              @for (preferredShareClass of propertyTransferredResults.preferredSharesClasses; track preferredShareClass; let i = $index) {
                <div>
                  {{ preferredShareClass.adjustedCostBase | currencyCents | notAvailable }}
                </div>
              }
            </td>
            <td>
              @for (commonShareClass of propertyTransferredResults.commonSharesClasses; track commonShareClass; let i = $index) {
                <div>
                  {{ commonShareClass.paidUpCapital | currencyCents | notAvailable }}
                </div>
              }
              @for (preferredShareClass of propertyTransferredResults.preferredSharesClasses; track preferredShareClass; let i = $index) {
                <div>
                  {{ preferredShareClass.paidUpCapital | currencyCents | notAvailable }}
                </div>
              }
            </td>
            <td>
              @for (commonShareClass of propertyTransferredResults.commonSharesClasses; track commonShareClass; let i = $index) {
                <div>
                  {{ commonShareClass.fairMarketValue | currencyCents | notAvailable }}
                </div>
              }
              @for (preferredShareClass of propertyTransferredResults.preferredSharesClasses; track preferredShareClass; let i = $index) {
                <div>
                  {{ preferredShareClass.fairMarketValue | currencyCents | notAvailable }}
                </div>
              }
            </td>
          </tr>
        </tbody>
      }
      <tbody>
        <tr>
          <th scope="row">Total pour tous les biens</th>

          <td>{{ results.fairMarketValueOfAllProperties | currencyCents | notAvailable }}</td>
          <td>{{ results.costAmountOfAllProperties | currencyCents | notAvailable }}</td>
          <td class="table-col-split">{{ results.agreedAmountOfAllProperties | currencyCents | notAvailable }}</td>
          <td>
            @for (nonShareConsideration of results.nonShareConsiderations; track nonShareConsideration; let i = $index) {
              <span>
                @if (shouldShowNonShareConsideration(nonShareConsideration)) {
                  <div>
                    {{ getTitleForNonShareConsideration(nonShareConsideration) }}
                  </div>
                }
              </span>
            }
          </td>
          <td class="table-col-split">
            @for (nonShareConsideration of results.nonShareConsiderations; track nonShareConsideration; let i = $index) {
              <span>
                @if (shouldShowNonShareConsideration(nonShareConsideration)) {
                  <div>
                    {{ nonShareConsideration.amountOfNonShareConsideration | currencyCents | notAvailable }}
                  </div>
                }
              </span>
            }
          </td>
          <td>
            @for (commonShareClass of results.commonSharesClasses; track commonShareClass; let i = $index) {
              <div>
                {{ commonShareClass.numberOfShares }} {{ commonShareClass.title }}
              </div>
            }
            @for (preferredShareClass of results.preferredSharesClasses; track preferredShareClass; let i = $index) {
              <div>
                {{ preferredShareClass.numberOfShares }} {{ preferredShareClass.title }}
              </div>
            }
          </td>
          <td>
            @for (commonShareClass of results.commonSharesClasses; track commonShareClass; let i = $index) {
              <div>
                {{ commonShareClass.totalAdjustedCostBase | currencyCents | notAvailable }}
              </div>
            }
            @for (preferredShareClass of results.preferredSharesClasses; track preferredShareClass; let i = $index) {
              <div>
                {{ preferredShareClass.totalAdjustedCostBase | currencyCents | notAvailable }}
              </div>
            }
          </td>
          <td>
            @for (commonShareClass of results.commonSharesClasses; track commonShareClass; let i = $index) {
              <div>
                {{ commonShareClass.totalPaidUpCapital | currencyCents | notAvailable }}
              </div>
            }
            @for (preferredShareClass of results.preferredSharesClasses; track preferredShareClass; let i = $index) {
              <div>
                {{ preferredShareClass.totalPaidUpCapital | currencyCents | notAvailable }}
              </div>
            }
          </td>
          <td>
            @for (commonShareClass of results.commonSharesClasses; track commonShareClass; let i = $index) {
              <div>
                {{ commonShareClass.totalFairMarketValue | currencyCents | notAvailable }}
              </div>
            }
            @for (preferredShareClass of results.preferredSharesClasses; track preferredShareClass; let i = $index) {
              <div>
                {{ preferredShareClass.totalFairMarketValue | currencyCents | notAvailable }}
              </div>
            }
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>